exports.TabsBar = require('./_subs/TabsBar').default
exports.TabsContent = require('./_subs/TabsContent').default
exports.TabsContentItem = require('./_subs/TabsContentItem').default
